export const WheelSetStatus = {
  MissingMeasurements: `MissingMeasurements`,
  WornOut: `WornOut`,
  Satisfactory: `Satisfactory`,
  SoonWornOut: `SoonWornOut`
} as const;

export type WheelSetStatusType = keyof typeof WheelSetStatus;
